/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Select_Event_GroupInputs */

const en_offline_sync_select_event_group = /** @type {(inputs: Offline_Sync_Select_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select an Event Group to sync.`)
};

const fr_offline_sync_select_event_group = /** @type {(inputs: Offline_Sync_Select_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez sélectionner un groupe d'événements à synchroniser.`)
};

const de_offline_sync_select_event_group = /** @type {(inputs: Offline_Sync_Select_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie eine Ereignisgruppe zum Synchronisieren aus.`)
};

const it_offline_sync_select_event_group = /** @type {(inputs: Offline_Sync_Select_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un gruppo eventi da sincronizzare.`)
};

const ru_offline_sync_select_event_group = /** @type {(inputs: Offline_Sync_Select_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите группу событий для синхронизации.`)
};

const es_offline_sync_select_event_group = /** @type {(inputs: Offline_Sync_Select_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un grupo de eventos para sincronizar.`)
};

const zh_cn2_offline_sync_select_event_group = /** @type {(inputs: Offline_Sync_Select_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择要同步的事件组。`)
};

const ja_offline_sync_select_event_group = /** @type {(inputs: Offline_Sync_Select_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同期するイベントグループを選択してください。`)
};

const hi_offline_sync_select_event_group = /** @type {(inputs: Offline_Sync_Select_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिंक करने के लिए कृपया एक इवेंट समूह चुनें।`)
};

const pt_pt2_offline_sync_select_event_group = /** @type {(inputs: Offline_Sync_Select_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um grupo de eventos para sincronizar.`)
};

/**
* | output |
* | --- |
* | "Please select an Event Group to sync." |
*
* @param {Offline_Sync_Select_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_select_event_group = /** @type {((inputs?: Offline_Sync_Select_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Select_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_select_event_group(inputs)
	if (locale === "de") return de_offline_sync_select_event_group(inputs)
	if (locale === "it") return it_offline_sync_select_event_group(inputs)
	if (locale === "ru") return ru_offline_sync_select_event_group(inputs)
	if (locale === "es") return es_offline_sync_select_event_group(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_select_event_group(inputs)
	if (locale === "ja") return ja_offline_sync_select_event_group(inputs)
	if (locale === "hi") return hi_offline_sync_select_event_group(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_select_event_group(inputs)
	return en_offline_sync_select_event_group(inputs)
});